import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const FloorStampIcon = React.memo<IconProps>(
  ({ className = '', size = 12, width, height, color = 'currentColor', onClick, strokeWidth = 1.8 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Brush top */}
      <path d="M9 4h6v3H9z" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" fill="none" />
      {/* Brush body */}
      <path d="M7 7h10v4a2 2 0 01-2 2H9a2 2 0 01-2-2V7z" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" fill="none" />
      {/* Floor plate */}
      <rect x="5" y="15" width="14" height="3" rx="0.5" fill={color} />
      {/* Ground line */}
      <path d="M4 21h16" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </BaseIcon>
  ),
);

FloorStampIcon.displayName = 'FloorStampIcon';
